const MessagePush = () => import('@/pages/content-manage/MessagePush');
const AddMessagePush = () => import('@/pages/content-manage/AddMessagePush');
const MessagePushDetail = () => import('@/pages/content-manage/MessagePushDetail');
const SlideImgManage = () => import('@/pages/content-manage/SlideImgManage');
const CommentManage = () => import('@/pages/content-manage/CommentManage');
const HandleSlideImg = () => import('@/pages/content-manage/HandleSlideImg');

export default[
    {
      path: '/message-push',
      component: MessagePush,
      meta: [
        {
          name: '内容管理',
          url: '',
        },
        {
          name: '系统消息推送',
          url: '',
        },
      ],
    },
    {
      path: '/message-push/add-message-push',
      component: AddMessagePush,
      meta: [
        {
          name: '内容管理',
          url: '/message-push',
        },
        {
          name: '系统消息推送',
          url: '/message-push',
        },
        {
          name: '新增系统消息推送',
          url: '',
        },
      ],
    },
    {
      path: '/message-push/message-detail',
      component: MessagePushDetail,
      meta: [
        {
          name: '内容管理',
          url: '/message-push',
        },
        {
          name: '系统消息推送',
          url: '/message-push',
        },
        {
          name: '系统消息推送详情',
          url: '',
        },
      ],
    },
    {
      path: '/slideimg-manage',
      component: SlideImgManage,
      meta: [
        {
          name: '内容管理',
          url: '/message-push',
        },
        {
          name: '轮播图管理',
          url: '',
        },
      ],
    },
    {
      path: '/slideimg-manage/add-slide-img',
      component: HandleSlideImg,
      meta: [
        {
          name: '内容管理',
          url: '/message-push',
        },
        {
          name: '轮播图管理',
          url: '/slideimg-manage',
        },
        {
          name: '添加轮播图',
          url: '',
        },
      ],
    },
    {
      path: '/slideimg-manage/edit-slide-img',
      component: HandleSlideImg,
      meta: [
        {
          name: '内容管理',
          url: '/message-push',
        },
        {
          name: '轮播图管理',
          url: '/slideimg-manage',
        },
        {
          name: '编辑轮播图',
          url: '',
        },
      ],
    },
    {
      path: '/comment-manage',
      component: CommentManage,
      meta: [
        {
          name: '内容管理',
          url: '/message-push',
        },
        {
          name: '评论管理',
          url: '',
        },
      ],
    },
]
